/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Stream_ErrorInputs */

const vi_grower_area_camera_stream_error = /** @type {(inputs: Grower_Area_Camera_Stream_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không nhận được khung hình từ camera. Kiểm tra mạng tại vườn rồi thử lại.`)
};

/**

* @param {Grower_Area_Camera_Stream_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_stream_error = /** @type {((inputs?: Grower_Area_Camera_Stream_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Stream_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_stream_error(inputs)
});